import { Injectable } from '@angular/core';

@Injectable()
export class MaintenanceService {
  private showMaintenanceMessageOverlay = false;
  private showMaintenancePage = false;

  private organizationUnderMaintenance = false;

  setOrganizationMaintenance(underMaintenance: boolean): void {
    this.organizationUnderMaintenance = underMaintenance;
  }

  showMaintenanceMessage(): boolean {
    return this.showMaintenanceMessageOverlay;
  }

  shouldShowMaintenancePage(): boolean {
    return this.showMaintenancePage || this.organizationUnderMaintenance;
  }
}
